import { useEffect, useState } from "react";
import { Autoplay, Mousewheel, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import SkillSwiper from "./components/SkillSwiper";
import "swiper/css"; // swiper bundle styles
import "./App.css";
import { isMobile } from "react-device-detect";

function App() {
  const [fadeIn_section1, setFadeIn_section1] = useState(false); // section1의 fadeIn 효과를 위한 state
  const [fadeIn_section2, setFadeIn_section2] = useState(false); // section2의 fadeIn 효과를 위한 state

  useEffect(() => {
    // console.log(window.innerWidth);
    // console.log(window.innerHeight);
    setFadeIn_section1(true);
  }, []);

  const handlePageChange = (number: number) => {
    if (number === 0) {
      // section1
      console.log("section1 show");

      setFadeIn_section1(true);
      setTimeout(() => {
        setFadeIn_section2(false);
      }, 500);
    } else if (number === 1) {
      // section2
      console.log("section2 show");

      setFadeIn_section2(true);
      setTimeout(() => {
        setFadeIn_section1(false);
      }, 500);
    } else if (number === 2) {
      // section3
      console.log("section3 show");

      setFadeIn_section1(false);
      setFadeIn_section2(false);
    }
  };

  return (
    <div className="App">
      {!isMobile ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "black",
            height: "100vh",
          }}>
          <h1 style={{ color: "white", fontSize: "2rem", textAlign: "center" }}>
            모바일 환경에서만 사용 가능한 페이지입니다 😅😅 <br />
            <br />
            혹시 PC 환경에서 보고 싶으시다면.. 개발자 도구를 열고, <br />
            모바일 디바이스로 변경 후 새로고침 하시면 보입니다 🙇‍♂️🙇‍♂️
          </h1>
        </div>
      ) : (
        <>
          {/* Header */}
          <header className="header">
            <div className="header__logo" />
            <div className="header__menu">
              <div className="icon"></div>
              <span className="text">MENU</span>
            </div>
          </header>

          {/* Body */}
          <div className="body">
            <Swiper
              width={window.innerWidth}
              height={window.innerHeight}
              modules={[Mousewheel, Pagination]}
              direction="vertical"
              speed={1000}
              mousewheel={true}
              slidesPerView={1}
              onSlideChange={(swiper: any) => {
                handlePageChange(swiper.activeIndex);
              }}>
              {/* 섹션1 */}
              <SwiperSlide>
                <section className="section1">
                  <div className="section1__wrapper">
                    <span
                      className={`title ${
                        fadeIn_section1 ? "fadeIn delay500" : "hidden"
                      }`}>
                      FOCUS ON
                    </span>
                    <span
                      className={`subtitle ${
                        fadeIn_section1 ? "fadeIn delay500" : "hidden"
                      }`}>
                      WHAT I CAN DO
                    </span>
                    <span
                      className={`text ${
                        fadeIn_section1 ? "fadeIn delay1000" : "hidden"
                      }`}>
                      Park Jinwan's Portfolio
                    </span>
                  </div>
                </section>
              </SwiperSlide>
              {/* 섹션2 */}
              <SwiperSlide>
                <section className="section2">
                  <div className={`section2__header`}>
                    <span className="section-title">ABOUT</span>
                    <span className="name">Park Jinwan</span>
                  </div>
                  <span
                    className={`section2__content1 ${
                      fadeIn_section2 ? "fadeIn delay500" : "hidden"
                    }`}>
                    성공이란 <span className="red strong">단숨에</span> 얻는게
                    아닌
                    <br />
                    하루하루 <span className="red strong">꾸준한</span> 성장과
                    발전이
                    <br />
                    차곡차곡 <span className="red strong">쌓여져</span>{" "}
                    이루어진다
                  </span>
                  <span
                    className={`section2__content2 ${
                      fadeIn_section2 ? "fadeIn delay1000" : "hidden"
                    }`}>
                    "안녕하세요. 5년차 개발자 박진완입니다" <br />
                    "현재 LG CNS에서 마이데이터 도메인 프로젝트를 진행 중
                    입니다" <br />
                  </span>
                  <div
                    className={`circle-wrapper ${
                      fadeIn_section2 ? "fadeIn delay1500" : "hidden"
                    }`}>
                    <div className="circle">자기개발</div>
                    <div className="circle">책임감</div>
                    <div className="circle">의사소통</div>
                  </div>
                  <div
                    className={`circle-wrapper ${
                      fadeIn_section2 ? "fadeIn delay1500" : "hidden"
                    }`}
                    style={{ top: "-6vh" }}>
                    <div className="circle">자신감</div>
                    <div className="circle">적극성</div>
                  </div>
                  <div
                    className={`circle-footer ${
                      fadeIn_section2 ? "fadeIn delay1500" : "hidden"
                    }`}>
                    <span className="circle-footer-text">
                      추구하는 5가지 핵심역량
                    </span>
                  </div>
                </section>
              </SwiperSlide>
              {/* 섹션3 */}
              <SwiperSlide>
                <section className="section3">
                  <div className="section3__wrapper">
                    <div className="section3__header">
                      <span className="section-title">SKILLS</span>
                    </div>
                    <div className="section3__content">
                      <span className="swiper-label">Front End</span>
                      <SkillSwiper area="front" />
                      <span className="swiper-label">Back End</span>
                      <SkillSwiper area="back" />
                      <span className="swiper-label">Others</span>
                      <SkillSwiper area="others" />
                    </div>
                    <div className="section3__footer">
                      <div className="section3__footer-wrapper">
                        <div className="arrow-more"></div>
                        <span>VIEW MORE</span>
                      </div>
                    </div>
                  </div>
                </section>
              </SwiperSlide>
              {/* 섹션4 */}
              <SwiperSlide>
                <section className="section4">
                  <div className="section4__wrapper">
                    <div className="section4__header">
                      <span className="section-title">PROJECTS</span>
                    </div>
                    <div className="section4__content">
                      <Swiper
                        direction="horizontal"
                        modules={[Autoplay]}
                        slidesPerView={1.2}
                        autoplay={{
                          delay: 3000,
                          disableOnInteraction: false,
                        }}
                        loop={true}
                        speed={1000}
                        style={{
                          backgroundColor: "black",
                          border: "solid 2px aliceblue",
                          borderRadius: "10px",
                        }}
                        spaceBetween={10}>
                        <SwiperSlide>
                          <div className="project-slide-img haruzogak">
                            <div className="project-slide-bottom">
                              <span>
                                <strong
                                  style={{
                                    fontWeight: "bold",
                                  }}>
                                  하루조각
                                </strong>{" "}
                                (2022. 10월 ~ 현재)
                              </span>
                            </div>
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="project-slide-img kbmobile">
                            <div className="project-slide-bottom">
                              <span>
                                <strong
                                  style={{
                                    fontWeight: "bold",
                                  }}>
                                  KB모바일
                                </strong>{" "}
                                (2021. 5월 ~ 2022. 9월)
                              </span>
                            </div>
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="project-slide-img haruzogak">
                            <div className="project-slide-bottom">
                              <span>
                                <strong
                                  style={{
                                    fontWeight: "bold",
                                  }}>
                                  하루조각
                                </strong>{" "}
                                (2022. 10월 ~ 현재)
                              </span>
                            </div>
                          </div>
                        </SwiperSlide>
                        <SwiperSlide>
                          <div className="project-slide-img kbmobile">
                            <div className="project-slide-bottom">
                              <span>
                                <strong
                                  style={{
                                    fontWeight: "bold",
                                  }}>
                                  KB 모바일
                                </strong>{" "}
                                (2021. 5월 ~ 2022. 9월)
                              </span>
                            </div>
                          </div>
                        </SwiperSlide>
                      </Swiper>
                    </div>
                    <div className="section4__footer"></div>
                  </div>
                </section>
              </SwiperSlide>
            </Swiper>
          </div>

          {/* Footer */}
          {/* <footer className="footer"></footer> */}
        </>
      )}
    </div>
  );
}

export default App;
